import React from "react";
import { useInView } from "react-intersection-observer";
import profileimg from "../images/profile-img.png";

const AboutSection = () => {
  const { ref: aboutSectionTitleRef, inView: aboutSectionTitleIsVisible } =
    useInView({
      triggerOnce: true,
    });

  return (
    <section className="about-me-section">
      <div className="about-title-div">
        <h1
          ref={aboutSectionTitleRef}
          className={`${
            aboutSectionTitleIsVisible
              ? "about-title show-title"
              : "about-title"
          }`}
        >
          About me
        </h1>
        <div className="title-underline"></div>
      </div>

      <div className="about-me-container">
        <div className="about-me-div">
          <article className="about-me-text-container">
            <h6 className="about-me-title">
              Hi again! Thank you for reading this far!
            </h6>
            <p className="about-paragraph">
              {" "}
              As a front-end developer{" "}
              <span className="small-text"> ( An awesome one! )</span>,
              <span className="key-point">
                I am very enthusiastic about technology and it's latest trends.
              </span>
              . It has been a natural passion. Even before obtaining my
              Bachelor’s{" "}
              <span className="key-point">
                Degree in Computer Science and Mathematics
              </span>
              , I have always been highly fascinated with computers, technology
              and innovations. My aspiration has been to become a full-time
              software engineer and lead technical innovations around the world.
              I look forward to working with other great technology enthusiasts
              to create cutting-edge solutions.
              <span className="small-text">
                {" "}
                (to make life easier for everyone!)
              </span>
              ,
            </p>

            <p className="about-paragraph">
              I have worked with Product designers to bring designs to life. I
              translate UI design concepts into user-friendly and visually
              appealing web applications by leveraging the power of React and
              Next.js to create intuitive, interactive, scalable and highly
              performant web applications that leaves lasting imppresion and
              also with server-side rendering capabilities. I have also
              collaborated with backend engineers to ensure that both the client
              and server side logic including the API data fetched and
              transfered between the server and the client work seamlessly
              together.
            </p>

            <p className="about-paragraph">
              In tandem, It's also been a bliss utilizing the great services
              that the Git version control system provides{" "}
              <span className="small-text">
                {" "}
                ( bless open source communities! )
              </span>{" "}
              for graceful team work, collaborations and production.
            </p>

            <p className="open-for-op">
              I optimistic and fully ready for opportunities where I can
              continue to contribute solutions while also honing my skills and
              staying up to date in this career journey.
            </p>
          </article>

          <div className="about-me-img-div">
            <img src={profileimg} alt="profile" className="about-me-img" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
